<template>
	<div>
		<form-data :list="groupinfo" @getAuth="getAuth" />
	</div>
</template>

<script>
	import './editgroup.less'
    import {editregistergroup} from '@/libs/api'
    import formData from '@/components/form'
    import {setStorage, getStorage, removeStorage, goBack} from '@/libs/utils'

    export default {
        name: 'mainapply',
        components: {
            formData
        },
        data() {
            return {
                postparams: {},
                groupinfo: []
            }
        },
        methods:{
            getAuth(data){
	            if(data){
			        var params = this.postparams;
			        params.groupjson = JSON.stringify(data);
			        editregistergroup(params).then((res) => {
			            if(res.status==200)
			            {
			                removeStorage('editgroupinfo');
			                this.$router.replace({name:'manage'});
			            }
			        })
	            }    
	        }
        },
        mounted(options) {
            this.$nextTick(() => {
                try {
		            var res = getStorage('editgroupinfo');
		            this.groupinfo = res.groupinfo
		            this.postparams = res
		        } catch (e) {
		            console.log(e);
		        }
            })
        }
        
    }
</script>